import type { ActivityLocation } from "./types";

export function extractSocialNetworkUrl(url: string): string | null {
    const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9]+)/);
    return match ? match[1] : null;
}

export function extractSocialNetworkName(url: string): string | null {
    const socialNetwork = extractSocialNetworkUrl(url);

    if (!socialNetwork) return null;

    for (const network of supportedSocialNetworks) {
        if (socialNetwork.includes(network)) {
            return network;
        }
    }
    return null;
};

export const supportedSocialNetworks: string[] = [
    "facebook",
    "instagram",
    "linkedin",
    "tiktok",
    "twitter",
    "x",
    "youtube"
];

export const ucfirst = (str: string): string => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
};

const ucfirstAllWords = (str: string, exceptions: string[] = []) => {
    if (!str) return str;

    let input = str.toLocaleLowerCase();
    const parts: string[] = [];
    while (str.length !== parts.join('').length) {
        const halves = input.match(/^(.+?)([- '])(.+)/);
        if (halves) {
            const p = halves[1];
            parts.push(exceptions.includes(p) ? p : ucfirst(p), halves[2]);
            input = halves[3];
        } else {
            parts.push(ucfirst(input));
            break;
        }
    }
    // always ucfirst first and last word
    parts[0] = ucfirst(parts[0]);
    parts[parts.length - 1] = ucfirst(parts[parts.length - 1]);
    return parts.join('');
};

export function displayLocation(lieu: ActivityLocation): string {
    function format(str: string): string {
        return ucfirstAllWords(str.trim(), ['de', 'la', 'du', 'des', 'le', 'les', 'et', 'au', 'aux', 'sur', 'sous', 'l', "d", "en"]);
    }
    if (ucfirst(lieu.pays) === "France" || !lieu.pays) {
        const departementNumber = lieu.codePostal?.slice(0, 2) ?? "-";
        const displayedDepartementNumber = departementNumber === '97' ? lieu.codePostal.slice(0, 3) : departementNumber;
        if (lieu.ville)
            return `${format(lieu.ville)} (${displayedDepartementNumber})`;
        else
            return `(${displayedDepartementNumber})`;
    } else {
        if (lieu.ville)
            return `${format(lieu.ville)} (${format(lieu.pays)})`;
        else
            return `${format(lieu.pays)}`;
    }
}